module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-section section-15 pipelines-time-ago"
  }, [_c('div', {
    staticClass: "table-mobile-header",
    attrs: {
      "role": "rowheader"
    }
  }, [_vm._v("\n      Duration\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-mobile-content"
  }, [(_vm.hasDuration) ? _c('p', {
    staticClass: "duration"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.iconTimerSvg)
    }
  }), _vm._v("\n        " + _vm._s(_vm.durationFormated) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.hasFinishedTime) ? _c('p', {
    staticClass: "finished-at hidden-xs hidden-sm"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('time', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    attrs: {
      "data-placement": "top",
      "data-container": "body",
      "title": _vm.tooltipTitle(_vm.finishedTime)
    }
  }, [_vm._v("\n          " + _vm._s(_vm.timeFormated(_vm.finishedTime)) + "\n        ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709158ab"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/time_ago.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-709158ab"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/time_ago.vue
// module chunks = commit_pipelines pipelines